import * as React from 'react'

function IconGeo() {
  return (
    <svg
      width={17}
      height={23}
      viewBox="0 0 17 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 0C3.806 0 0 3.94 0 8.8c0 4.61 3.736 10.007 6.254 13.12a2.849 2.849 0 004.473-.007C13.244 18.768 17 13.317 17 8.8 17 3.94 13.194 0 8.5 0zm0 12.897c-2.207 0-3.996-1.852-3.996-4.137 0-2.279 1.789-4.13 3.996-4.13s3.996 1.851 3.996 4.13c0 2.285-1.789 4.137-3.996 4.137z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconGeo
